import React from 'react';
import { AlertTriangleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-bg-section py-16 md:py-24 px-4" data-id="element-401">
      <div className="max-w-5xl mx-auto" data-id="element-402">
        <div className="text-center mb-12 md:mb-16" data-id="element-403">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-red-500/10 rounded-full mb-4 md:mb-6" data-id="element-404">
            <AlertTriangleIcon className="w-6 h-6 md:w-8 md:h-8 text-red-400" data-id="element-405" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6" data-id="element-406">
            Registrar tu empresa no es suficiente
          </h2>
          <p className="text-base md:text-xl text-text-secondary leading-relaxed max-w-3xl mx-auto" data-id="element-407">
            Miles de emprendedores registran sus empresas cada año, pero pocos
            construyen la infraestructura completa que necesitan para operar
            correctamente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12" data-id="element-408">
          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-red-500/20" data-id="element-409">
            <XCircleIcon className="w-6 h-6 md:w-8 md:h-8 text-red-400 mb-3 md:mb-4" data-id="element-410" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-411">
              Sin estructura fiscal
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-412">
              Registrar la empresa sin configurar correctamente la identidad
              fiscal ante el IRS crea vulnerabilidades y complicaciones futuras.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-red-500/20" data-id="element-413">
            <XCircleIcon className="w-6 h-6 md:w-8 md:h-8 text-red-400 mb-3 md:mb-4" data-id="element-414" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-415">
              Sin infraestructura financiera
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-416">
              Operar sin cuenta bancaria empresarial y sin separación de
              finanzas personales expone tu patrimonio personal y limita tu
              crecimiento.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-red-500/20" data-id="element-417">
            <XCircleIcon className="w-6 h-6 md:w-8 md:h-8 text-red-400 mb-3 md:mb-4" data-id="element-418" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-419">
              Sin sistema de cumplimiento
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-420">
              Ignorar los Annual Reports y las obligaciones fiscales puede
              resultar en multas, pérdida del estatus legal, o disolución
              involuntaria.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg border border-red-500/20" data-id="element-421">
            <XCircleIcon className="w-6 h-6 md:w-8 md:h-8 text-red-400 mb-3 md:mb-4" data-id="element-422" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-423">
              Sin control real
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-424">
              Una empresa sin infraestructura completa es una empresa
              vulnerable. No tienes control real sobre tu negocio.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-cta/10 to-transparent border-l-4 border-cta p-6 md:p-8 rounded-lg" data-id="element-425">
          <p className="text-base md:text-lg leading-relaxed" data-id="element-426">
            <span className="font-semibold text-cta" data-id="element-427">La realidad:</span> Una
            empresa correctamente estructurada requiere más que un registro.
            Necesita una{' '}
            <span className="font-semibold" data-id="element-428">
              Infraestructura Única de Valor
            </span>{' '}
            que integre los aspectos legales, fiscales, financieros y de
            cumplimiento en un sistema completo.
          </p>
        </div>
      </div>
    </section>;
}